import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import sportsSlice from '../reducers/sports.slice'

const persistConfig = {
  key: 'sportsSlice',
  storage,
}

export const persistedSportsReducer = persistReducer(persistConfig, sportsSlice)